// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.functional-structure {
  /* display: flex; */
  flex-grow: 1;
  min-width: 1500px;
}
.functional-structure--wrapper {
  width: 100vw;
  overflow-x: scroll;
}
.my-tree {
  overflow: auto;
}

.employee-personSchedules--wrapper,
.employee-personAttainment--wrapper {
  width: 925px;
}

.functional-structure--tree .p-panel-content {
  display: flex;
}

.p-tree-container {
  height: calc(100% - 50px);
}

.detailInfo-functional-structure .p-panel-content {
  padding-top: 0 !important;
}

.user-card__label{
  min-width: 150px
}`, "",{"version":3,"sources":["webpack://./src/ui/css/FunctionalStructure.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;AACF","sourcesContent":[".functional-structure {\n  /* display: flex; */\n  flex-grow: 1;\n  min-width: 1500px;\n}\n.functional-structure--wrapper {\n  width: 100vw;\n  overflow-x: scroll;\n}\n.my-tree {\n  overflow: auto;\n}\n\n.employee-personSchedules--wrapper,\n.employee-personAttainment--wrapper {\n  width: 925px;\n}\n\n.functional-structure--tree .p-panel-content {\n  display: flex;\n}\n\n.p-tree-container {\n  height: calc(100% - 50px);\n}\n\n.detailInfo-functional-structure .p-panel-content {\n  padding-top: 0 !important;\n}\n\n.user-card__label{\n  min-width: 150px\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
